import { useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Resets window scroll to (0, 0) whenever the route's pathname changes.
// Mount once inside <BrowserRouter>, above <Routes>. Returns null so it
// adds nothing to the DOM.
//
// Watches pathname only — in-page hash navigation (#section anchors) and
// query-string updates do not trigger a scroll reset.
//
// useLayoutEffect (not useEffect) so the scroll happens before paint,
// preventing a one-frame flash of the new page at the old scroll position.
export default function ScrollToTop() {
  const { pathname } = useLocation();

  useLayoutEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}
